<template>
  <div class="flex min-h-screen flex-col" :style="{ background: 'var(--bg)', color: 'var(--ink)', '--page-max': `${route.meta.maxWidth ?? 1280}px` }">
    <AppNav />
    <AppSubBar />
    <main class="flex-1">
      <NuxtPage />
    </main>
    <UToaster />
    <AppConfirmDialog />
  </div>
</template>

<script setup lang="ts">
// Pure shell: top bar + contextual sub-bar + routed page.
// --page-max keeps the bars as wide as the page; pages wider or narrower than 1280 set meta.maxWidth.
const route = useRoute()
</script>
